import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ErrorLayout from './ErrorLayout';


import style from './style.css';
import somethingWentWrong from './img/something-went-wrong.svg';


const messages = {
  errorTitle: { id: 'SEARCH_RESULTS.ERROR_MESSAGE' },
  defaultErrorMessage: { id: 'ERRORS.UNKNOWN_ERROR' }
};

export const UnknownError = (props) => {
  const image = <img className={style.image} src={somethingWentWrong} alt="error" />;
  const { message } = props;

  let preparedMessage = null;
  if (_.isObject(message)) {
    preparedMessage = _.has(message, 'id') ? message : messages.defaultErrorMessage;
  }

  return (
    <ErrorLayout
      {...props}
      titleMessage={messages.errorTitle}
      image={image}
      message={preparedMessage || message}
    />
  );
};

// TODO: move to Flow types
// UnknownError.propTypes = {
//   className: PropTypes.string,
//   mobile: PropTypes.bool,
//   message: PropTypes.oneOfType([
//     PropTypes.object,
//     PropTypes.string
//   ]),
//   tryAgain: PropTypes.func
// };

const mapStateToProps = (state) => ({
  message: state.searchResults.errored?.message
});

export default connect(mapStateToProps)(UnknownError);
